import { findParent } from './utils';

export default class Share {

	constructor() {
		this.handleLinkClick = this.handleLinkClick.bind(this);
		this.links = document.querySelectorAll('.gigs-share__link');
		this.widthAttribute = 'data-window-width';
		this.heightAttribute = 'data-window-height';
	}

	init() {
		this.links.forEach(link => {
			link.addEventListener('click', this.handleLinkClick);
		});
	}

	destroy() {
		this.links.forEach(link => {
			link.removeEventListener('click', this.handleLinkClick);
		});
	}

	handleLinkClick(e) {
		const { target } = e;
		const link = findParent(target, (element) => element.classList.contains('gigs-share__link'));
		if (link instanceof HTMLElement) {
			e.preventDefault();
			const widthAttribute = link.getAttribute(this.widthAttribute);
			const heightAttribute = link.getAttribute(this.heightAttribute);
			const width = widthAttribute ? parseInt(widthAttribute, 10) : 650;
			const height = widthAttribute ? parseInt(heightAttribute, 10) : 500;
			window.open(
				link.href,
				'targetWindow',
				`toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,innerWidth=${width},innerHeight=${height},top=50,left=50`
			);
		}
	}
}